// Imports for external libraries go here.
import React, { FC } from 'react';
// Imports for internal (to the monorepo) libraries go here,
// separated by a blank line from external imports.
// The closer the import is to the file the lower it should be in this list.
import { EditableComponent } from '@adobe/aem-react-editable-components';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { MerchandisingTileSkinnyNonEditable as MerchandisingTileSkinny } from '@marriott/mi-merch-components';
import { getMediaDataSecondary } from '../../utils/OfferUtils';
import { SECONDARY_MEDIA } from '../../constants/CommonConstants';
import { OffersMerchandizingTileSkinnyProps } from './OffersMerchandizingTileSkinny.types';
import { StyledOffersMerchandizingTileSkinny } from './OffersMerchandizingTileSkinny.styles';
import { useClientEnvVarsStore } from '@marriott/mi-store-utils';
// Use named rather than default exports.
export const OffersMerchandizingTileSkinnyConfig = {
  emptyLabel: 'OffersMerchandizingTileSkinnyWrapper',
  isEmpty: false,
  resourceType: `mi-aem-common-spa/components/content/tileskinny`,
};
export const OffersMerchandizingTileSkinnyWrapper: FC<OffersMerchandizingTileSkinnyProps> = props => {
  const { model, offersData, isAuthorMode } = props;
  const { envVarsObject } = useClientEnvVarsStore();
  const imageDomain = envVarsObject?.['UXL_IMAGE_CACHE_DOMAIN'];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const offersDataNode = offersData?.responseObject?.edges[0];
  const merchandisingNode = offersDataNode?.merchandisingNode;
  const node = offersDataNode?.node;

  const mediaSource = isAuthorMode ? 'model' : SECONDARY_MEDIA;
  const media = isAuthorMode
    ? model?.image || node?.media
    : getMediaDataSecondary(node?.media, model?.image, imageDomain, mediaSource);
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const requiredProps: any = {
    headerShort: merchandisingNode?.headerShort ?? model?.headerShort,
    descriptionShort: merchandisingNode?.descriptionShort ?? model?.descriptionShort,
    headerTag: model?.headerTag,
    destinationUrl1: node?.callToActionLink ?? model?.destinationUrl1,
    image: media,
    mboxParameter: model?.mboxParameter,
    displayEvergreenContent: model?.displayEvergreenContent ?? 'true',
    trackingProperties: model?.trackingProperties,
    openInaNewTab: model?.openInaNewTab,
  };

  return (
    <StyledOffersMerchandizingTileSkinny
      data-testid="offers-OffersMerchandizingTileSkinny"
      data-component-name="o-offers-OffersMerchandizingTileSkinny"
    >
      <MerchandisingTileSkinny {...requiredProps} />
    </StyledOffersMerchandizingTileSkinny>
  );
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const OffersMerchandizingTileSkinny = (props: any) => (
  <div data-component-name="o-offers-OffersMerchandizingTileSkinny" data-testid="offers-OffersMerchandizingTileSkinny">
    <EditableComponent config={OffersMerchandizingTileSkinnyConfig} {...props}>
      <OffersMerchandizingTileSkinnyWrapper {...props} />
    </EditableComponent>
  </div>
);
